module.exports = __webpack_public_path__ + "static/media/carteBleue.svg.3af345df.png";